export const PLAYGROUND_GENERATED_ENGINE_ID = 'playground-generated-draft';
